import { FileDrop } from "react-file-drop";
import { useState } from "react";
import { useStore } from "../../../stores/use_global_state";
import style from "./FileInput.module.scss";
import { Loading_ellipsis } from "../../loading";
import CoinsIcon from "../../../public/workspace/coins_stack.svg";
import UploadIcon from "../../../public/ico/upload_icon.svg";

function FileInput({ dictionary, uploadFile = () => {}, isLoading = false, creditCost, checkNonAuth }) {
	const { state } = useStore();
	const [onFrameDragEnter, setOnFrameDragEnter] = useState(false);
	const isLoad = !state.load || isLoading;

	const handleDropFile = (files, event) => {
		event.preventDefault();
		if (!checkNonAuth()) uploadFile(files);
	};

	const handleFilePut = ({ target }) => {
		uploadFile(target.files);
		target.value = "";
	};

	return (
		<>
			<div className={style.innerWrapper} style={{ opacity: onFrameDragEnter ? 0.5 : 1 }}>
				{isLoad ? (
					<Loading_ellipsis big="true" color={"#6371de"} />
				) : (
					<FileDrop className={`${style.dropArea}`} onDragOver={() => setOnFrameDragEnter(true)} onDragLeave={() => setOnFrameDragEnter(false)} onDrop={handleDropFile}>
						<input className={style.input} onChange={handleFilePut} disabled={!state.isAuth} type="file" name="" id="avatar-photo" accept={`.jpg, .jpeg, .heic, .heif, .png, image/png, image/jpeg`} />
						<label className={style.label} htmlFor="avatar-photo" onClick={checkNonAuth}>
							<span className={style.accent}>{dictionary["Upload file"]}</span> {dictionary["or Drag file here"].toLowerCase()}
							<span className={style.creditsInfo}>
								<CoinsIcon className={style.coinIcon} /> 1 {dictionary["option"]["Image"]?.toLowerCase() || "image"} = {dictionary[creditCost] || creditCost}
							</span>
						</label>
						<label className={style.labelAdaptive} htmlFor="avatar-photo" onClick={checkNonAuth}>
							<UploadIcon className={style.uploadIcon} />
							<span>{dictionary["Upload file"] || "Upload file"}</span>
						</label>
						<span className={`${style.creditsInfo} ${style.adaptive}`}>
							<CoinsIcon className={style.coinIcon} /> 1 {dictionary["option"]["Image"]?.toLowerCase() || "image"} = {dictionary[creditCost] || creditCost}
						</span>
					</FileDrop>
				)}
			</div>
		</>
	);
}

export default FileInput;
